import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import * as S from "./styled";
//Hooks
import useLoading from '../../../../hooks/useLoading';
import apiRequest from "../../../../hooks/apiRequest";
//Components
import LayoutModal from "../../../LayoutModal";
//Inteface
import { Inputs } from "Interfaces/IAccessory";
import { ICreate } from "Interfaces/ICreate";

export default function CreateAcessory({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    control,
    reset,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const toUpperCaseStrings = (obj: Record<string, any>) => {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        typeof value === 'string' ? value.toUpperCase() : value,
      ])
    );
  };

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = toUpperCaseStrings(data);
      const response = await apiRequest<Inputs>('accessory', 'POST', payload);
      if (response.status === 201) {
        setToastData({
          status: response.status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();

      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  }

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Acessório"
        subTitle="Cadastre um novo acessório em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}

        nameIconMinimize={'Registrar Acessório'}
      >
        <S.Container>
          <S.FormInput>
            <S.Label>
              Nome do Acessório
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Informe o nome"
              type="text"
              {...register("name", { required: true })}
            />
            {errors.name && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Quantidade
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe a quantidade"
                type="number"
                {...register("amount", { required: true })}
              />
              {errors.amount && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Preço
                <span>*</span>
              </S.Label>
              <Controller
                name="price"
                control={control}
                rules={{ required: 'Campo Obrigatório' }}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="R$ 0,00"
                    prefix="R$ "
                    value={value}
                    onValueChange={(values) => {
                      const purchaseValue = values.floatValue ?? 0;
                      onChange(purchaseValue); // Atualiza o valor de compra
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors.price && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>
          </S.SeparateDiv>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
